/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminUpdatePalletOrderRequest
 */
export interface AdminUpdatePalletOrderRequest {
    /**
     * 
     * @type {number}
     * @memberof AdminUpdatePalletOrderRequest
     */
    items: number;
    /**
     * 
     * @type {number}
     * @memberof AdminUpdatePalletOrderRequest
     */
    junkItems?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdatePalletOrderRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdatePalletOrderRequest
     */
    orderDate: string;
    /**
     * 
     * @type {string}
     * @memberof AdminUpdatePalletOrderRequest
     */
    orderLink: string;
    /**
     * 
     * @type {number}
     * @memberof AdminUpdatePalletOrderRequest
     */
    price: number;
}

export function AdminUpdatePalletOrderRequestFromJSON(json: any): AdminUpdatePalletOrderRequest {
    return AdminUpdatePalletOrderRequestFromJSONTyped(json, false);
}

export function AdminUpdatePalletOrderRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminUpdatePalletOrderRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': json['items'],
        'junkItems': !exists(json, 'junkItems') ? undefined : json['junkItems'],
        'name': json['name'],
        'orderDate': json['orderDate'],
        'orderLink': json['orderLink'],
        'price': json['price'],
    };
}

export function AdminUpdatePalletOrderRequestToJSON(value?: AdminUpdatePalletOrderRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items,
        'junkItems': value.junkItems,
        'name': value.name,
        'orderDate': value.orderDate,
        'orderLink': value.orderLink,
        'price': value.price,
    };
}

